// extracted by mini-css-extract-plugin
export var containerDesktopView = "style-mod--container-desktop-view--65d68";
export var newTestimonialCard = "style-mod--new-testimonial-card--b5365";
export var newTestimonialContent = "style-mod--new-testimonial-content--7b8ec";
export var newTestimonialTitle = "style-mod--new-testimonial-title--85ff9";
export var newTestimonials = "style-mod--new-testimonials--15058";
export var swiperMobileView = "style-mod--swiper-mobile-view--9a42b";
export var tcLink = "style-mod--tc-link--32828";
export var tcTitle = "style-mod--tc-title--689b6";
export var testimonialCard = "style-mod--testimonial-card--19d18";
export var testimonialCardContainer = "style-mod--testimonial-card-container--560ca";
export var testimonialContent = "style-mod--testimonial-content--7e1dc";
export var testimonialDescription = "style-mod--testimonial-description--cd810";
export var testimonialFullWidth = "style-mod--testimonial-full-width--274a8";
export var testimonialImage = "style-mod--testimonial-image--f6109";
export var testimonialSlide = "style-mod--testimonial-slide--7e95f";
export var testimonialSlider = "style-mod--testimonial-slider--bf838";
export var testimonialTitle = "style-mod--testimonial-title--201a5";
export var testimonials = "style-mod--testimonials--87c83";